import React, { useCallback, useContext, useEffect, useState } from "react";
import { Pressable, StyleSheet, View, Text } from "react-native";
import {
  BG_STYLES,
  // BottomDrawer,
  Button,
  BUTTON_TYPE,
  COLORS,
  COMMON_STYLES,
  LazyImage,
  SIZE,
  Spinner,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { Crop } from "../../models/crop";
import SectionLayout from "../reusable/SectionLayout";
import { ResponsiveContext } from "app/context/ResponsiveUIContext";
import { rnNavigation } from "app/utils/appConfig";
import { trackEvent } from "../../utils/tracking";
import ToastAndroid from "app/mocks/ToastAndroid";
import { AxiosError } from "axios";
import fetchSubscribedCorps from "app/farmer360/KhetEdge/apis/fetchSubscribedCrops";
import {
  AdvisoryQueryType,
  AdvisoryResponse,
  CropDataPoint,
  QueryName,
  SowingDataPoint,
  SubScribedCrops,
} from "app/farmer360/KhetEdge/models/crop";
import CropCard from "app/farmer360/KhetEdge/components/crop/CropCard";
import { ROUTES as KHET_EDGE_ROUTES } from "app/farmer360/KhetEdge/routes/types";
import AddCropModal from "app/farmer360/KhetEdge/components/crop/AddCropModal";
import { CustomEventTypes } from "app/farmer360/KhetEdge/utils/events/CustomEventTypes";
import User from "app/farmer360/KhetEdge/models/user";
import { fetchUserDetails } from "app/farmer360/KhetEdge/apis/fetchUserDetails";
import { DIMENSION_WIDTH, SCREEN_HEIGHT } from "app/utils/common";
import RoundImageWithIcon from "app/farmer360/KhetEdge/components/reusable/RoundImageWithIcon";
import { CalendarGrid } from "app/farmer360/KhetEdge/components/Calender";
import { useTranslation } from "react-i18next";
import images from "app/farmer360/KhetEdge/assets/image";
import Okay from "app/farmer360/KhetEdge/components/reusable/Okay";
import useErrorModalState from "app/farmer360/KhetEdge/hooks/useErrorModalState";
import createSubscription from "app/farmer360/KhetEdge/apis/createSubscription";
import ErrorModal from "app/farmer360/KhetEdge/components/reusable/ErrorModal";
import SuccessIcon from "app/farmer360/KhetEdge/components/icons/SuccessIcon";
import { extractCropAndSowingDate } from "app/farmer360/KhetEdge/utils/helpers";
import BottomDrawer from "../../KhetEdge/components/reusable/BottomDrawer";

interface Props {
  farmerId: string;
  reload: () => void;
  isEditAllowed: boolean;
  highlight: boolean;
  name: string;
  phoneNumber: string;
  authReady?: boolean;
}

interface AddSowingRecordCTAProps {
  onClick: () => void;
}

interface FormData {
  crop: Crop | null;
  sowingDate: string;
  latLong: string;
  isTransplanted?: boolean;
}

const RenderItem = ({ item }: { item: SubScribedCrops }) => {
  const { id, data_points, status, is_active } = item;
  const crops: CropDataPoint | undefined = data_points.find(
    (i) => i.query_type === AdvisoryQueryType.CROP
  ) as CropDataPoint;
  const sowing_date: SowingDataPoint | undefined = data_points.find(
    (i) => i.query_type === AdvisoryQueryType.SOWING_DATE
  ) as SowingDataPoint;
  const stage: SowingDataPoint | undefined = data_points.find(
    (i) => i.query_type === AdvisoryQueryType.STAGE
  ) as SowingDataPoint;
  return (
    <CropCard
      key={id}
      cropName={crops?.value?.name || ""}
      cropImageUrl={crops?.value?.image || ""}
      sowingDate={sowing_date?.value || ""}
      transplantedDate={
        sowing_date?.query_name === QueryName.TransplantedDate
          ? sowing_date?.value
          : ""
      }
      stage={stage?.value || ""}
      status={status}
      statusStyles={{
        backgroundColor: is_active ? COLORS.primary100 : COLORS.neutral70,
      }}
      onClick={() => {
        if (is_active)
          rnNavigation({
            name: KHET_EDGE_ROUTES.ADVISORY,
            params: { advisoryId: item.id },
          });
      }}
    />
  );
};

const AddSowingRecordCTA = ({ onClick }: AddSowingRecordCTAProps) => {
  return (
    <Pressable onPress={onClick} style={styles.ctaContainer}>
      <View style={[styles.addCropBtn, styles.img84X84]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING1,
            VARIANTS_STYLES.EMPHASIZED,
            TEXT_STYLES.textPrimary100,
          ]}
        >
          +
        </Text>
      </View>
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral80,
          COMMON_STYLES["mt1/2"],
          COMMON_STYLES.textCenter,
          styles.ctaText,
        ]}
      >
        Add ongoing crops
      </Text>
    </Pressable>
  );
};

const CropCalendar = ({
  farmerId,
  reload,
  isEditAllowed,
  highlight,
  name,
  phoneNumber,
  authReady,
}: Props) => {
  const { t } = useTranslation();
  const { mediaStyles } = useContext(ResponsiveContext);
  const [isLoading, setIsLoading] = useState(true);
  const [farmerOngoingCrops, setFarmerOngoingCrops] = useState<
    SubScribedCrops[]
  >([]);
  const [formData, setFormData] = useState<FormData>({
    crop: null,
    sowingDate: "",
    latLong: "",
    isTransplanted: false,
  });
  const [userDetails, setUserDetails] = useState<User | null>(null);
  const [latLong, setlatLong] = useState("");

  const [currentStep, setCurrentStep] = useState(0);
  const [locationLoading, setLocationLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [advisoryData, setAdvisoryData] = useState<AdvisoryResponse | null>(
    null
  );
  const { errorModalState, setErrorModalState, hideErrorModal } =
    useErrorModalState();

  const { cropImage, cropName, sowingDate, cropId } =
    extractCropAndSowingDate(advisoryData);

  const handleSubscribe = useCallback(
    async (data: FormData) => {
      try {
        const { crop, latLong, sowingDate, isTransplanted } = data;
        const sowingDateId = isTransplanted ? 11 : 2;
        const payload = {
          plan_id: 1,
          data_queries: [
            {
              id: 1,
              value: crop?.id,
            },
            {
              id: 3,
              value: latLong,
            },
            {
              id: sowingDateId,
              value: sowingDate,
            },
          ],
        };
        const res = await createSubscription(payload);
        setAdvisoryData(res);
        setSubscribed(true);
        trackEvent(CustomEventTypes.AdvisorySubscriptionCreated, {
          farmerName: userDetails?.full_name,
          farmerMobile: userDetails?.phone_number,
          AdvisoryType: "KhetEdge",
          CropName: crop?.name || "",
          DateOfSowing: sowingDate,
          LatLong: latLong,
        });
        getCrops();
      } catch (error) {
        if (error instanceof AxiosError) {
          const data = error?.response?.data;
          const errorMessage =
            data?.data_queries?.[0] ||
            data?.error?.message ||
            data?.message ||
            data?.detail ||
            error?.message;
          setErrorModalState({
            show: true,
            message: errorMessage,
            actionNode: (
              <Okay
                onClick={() => hideErrorModal()}
                btnStyle={COMMON_STYLES.mt1}
              />
            ),
          });
        }
      }
    },
    [
      hideErrorModal,
      setErrorModalState,
      userDetails?.full_name,
      userDetails?.phone_number,
    ]
  );

  const processLocation = () => {
    trackEvent(CustomEventTypes.AdvisorySubscriptionLocationAdded, {
      farmerName: userDetails?.full_name,
      farmerMobile: userDetails?.phone_number,
      AdvisoryType: "KhetEdge",
      CropName: formData?.crop?.name || "",
      DateOfSowing: formData.sowingDate,
      LatLong: latLong,
    });
    handleSubscribe({ ...formData, latLong });
  };

  const handleAddLocation = () => {
    console.log("LOOCATION 1 -> ", latLong);
    setLocationLoading(true);
    if (latLong.length > 0) {
      console.log("LOOCATION 2 -> ", latLong);
      processLocation();
    } else if ("geolocation" in navigator) {
      console.log("LOOCATION 3 -> ", latLong);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latLong = `${position.coords.latitude},${position.coords.longitude}`;
          console.log("LOOCATION 4 -> ", latLong);
          setFormData((prev) => ({ ...prev, latLong }));
          setlatLong(latLong);
          processLocation();
        },
        (error) => {
          console.log("LOOCATION 5 -> ", latLong);
          setErrorModalState({
            show: true,
            message: "Please allow location from settings",
            actionNode: (
              <Okay
                onClick={() => hideErrorModal()}
                btnStyle={COMMON_STYLES.mt1}
              />
            ),
          });
        }
      );
    } else {
      console.log("LOOCATION 6 -> ", latLong);
      setErrorModalState({
        show: true,
        message: "Allow location access",
        actionNode: (
          <Okay onClick={() => hideErrorModal()} btnStyle={COMMON_STYLES.mt1} />
        ),
      });
    }
    setLocationLoading(false);
  };

  const getCrops = async () => {
    try {
      setIsLoading(true);
      const crops = await fetchSubscribedCorps();
      setFarmerOngoingCrops(crops);
    } catch (error) {
      if (error instanceof AxiosError) {
        const data = error?.response?.data;
        const errorMessage =
          data?.data_queries?.[0] ||
          data?.error?.message ||
          data?.message ||
          data?.detail ||
          error?.message;
        ToastAndroid.show(
          errorMessage || "Something went wrong",
          ToastAndroid.SHORT
        );
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    console.log("LOOCATION 11 -> ", latLong);
    if (!authReady) return;

    console.log("LOOCATION 12 -> ", latLong);
    if ("geolocation" in navigator) {
      console.log("LOOCATION 13 -> ", latLong);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latLong = `${position.coords.latitude},${position.coords.longitude}`;
          console.log("LOOCATION 14 -> ", latLong);
          setFormData((prev) => ({ ...prev, latLong }));
          setlatLong(latLong);
        },
        (error) => {
          console.log("LOOCATION 15 -> ", error.message);
        }
      );
    }
  }, [authReady]);

  useEffect(() => {
    if (!authReady) return;
    getCrops().finally(() => setIsLoading(false));
    return () => {
      document.cookie = "userAuthId=;";
    };
  }, [authReady]);

  useEffect(() => {
    const getUserDetails = async () => {
      setIsLoading(true);
      try {
        let user: User | null;
        user = await fetchUserDetails();
        if (user) {
          setUserDetails(user);
        }
      } catch (err) {
        ToastAndroid.show("Unable to fetch user details", ToastAndroid.SHORT);
      }
      setIsLoading(false);
    };
    getUserDetails();
  }, []);

  return (
    <SectionLayout
      title={"Ongoing Crops - KhetEdge"}
      description={""}
      loading={isLoading}
      onViewAllClick={() =>
        rnNavigation({
          name: KHET_EDGE_ROUTES.KHET_EDGE,
        })
      }
      isViewAllCTADisabled={farmerOngoingCrops.length <= 3}
      highlight={highlight}
    >
      <View
        style={[
          styles.gap1,
          mediaStyles({
            desktopStyle: COMMON_STYLES.row,
            mobileStyle: COMMON_STYLES.alignItemsCenter,
          }),
        ]}
      >
        {locationLoading ? <Spinner type="on-screen" /> : null}
        {farmerOngoingCrops.slice(0, 3).map((sowingRecord, index) => (
          <RenderItem item={sowingRecord} key={index} />
        ))}

        {isEditAllowed && (
          <AddSowingRecordCTA onClick={() => setCurrentStep(1)} />
        )}
      </View>

      {currentStep === 1 ? (
        <AddCropModal
          onSubmit={(crop) => {
            if (crop?.id) {
              setFormData({
                ...formData,
                crop,
                isTransplanted: crop?.is_transplanted,
              });
              setCurrentStep(2);
              trackEvent(CustomEventTypes.AdvisorySubscriptionCropSelected, {
                farmerName: userDetails?.full_name,
                farmerMobile: userDetails?.phone_number,
                AdvisoryType: "KhetEdge",
                CropName: crop.name,
              });
            }
          }}
          onClose={() => setCurrentStep(0)}
        />
      ) : null}

      <BottomDrawer
        visible={currentStep === 2}
        onClose={() => setCurrentStep(0)}
        closeOnBackdropPress
        modalStyle={{
          height: DIMENSION_WIDTH > 600 ? undefined : SCREEN_HEIGHT - 10,
        }}
      >
        <View
          style={[
            COMMON_STYLES.flex1,
            COMMON_STYLES.mb1,
            COMMON_STYLES["mv1/2"],
          ]}
        >
          <Text style={[TYPOGRAPHY.HEADING2, VARIANTS_STYLES.MEDIUM]}>
            {formData?.isTransplanted
              ? t("add_transplanation_date")
              : t("add_sowing_date")}
          </Text>
          {formData.crop ? (
            <View style={[COMMON_STYLES["mv1/2"]]}>
              <RoundImageWithIcon
                crop={formData.crop}
                key={formData.crop.id}
                isIcon
                imageStyle={styles.image}
                imageContainerStyle={styles.iconContainer}
                containerStyle={[COMMON_STYLES.row]}
                isImageSelected={false}
              />
            </View>
          ) : null}
          <CalendarGrid
            onDateSelected={(dateStr) => {
              if (dateStr) {
                const dateObj = new Date(dateStr);

                const day = String(dateObj.getDate()).padStart(2, "0");
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const year = dateObj.getFullYear();

                const formattedDate = `${day}-${month}-${year}`;
                setFormData({ ...formData, sowingDate: formattedDate });
              }
            }}
          />
          <View style={styles.footer}>
            <Button
              type={BUTTON_TYPE.SECONDARY}
              onClick={() => {
                setCurrentStep(1);
                setFormData({ ...formData, sowingDate: "" });
              }}
              text={t("button_back")}
              size={SIZE.large}
              buttonStyle={[COMMON_STYLES.flex1]}
            />
            <Button
              onClick={() => {
                if (formData.sowingDate) {
                  setCurrentStep(3);
                  trackEvent(
                    CustomEventTypes.AdvisorySubscriptionDateOfSowingSelected,
                    {
                      farmerName: userDetails?.full_name,
                      farmerMobile: userDetails?.phone_number,
                      AdvisoryType: "KhetEdge",
                      CropName: formData?.crop?.name || "",
                      DateOfSowing: formData.sowingDate,
                    }
                  );
                }
              }}
              text={t("button_next")}
              size={SIZE.large}
              buttonStyle={[COMMON_STYLES.flex1]}
            />
          </View>
        </View>
      </BottomDrawer>
      <BottomDrawer
        visible={currentStep === 3}
        onClose={() => setCurrentStep(0)}
        closeOnBackdropPress
      >
        <View style={[COMMON_STYLES.pb1, { gap: 16 }]}>
          <View>
            <Text style={[TYPOGRAPHY.HEADING2, VARIANTS_STYLES.MEDIUM]}>
              {t("send_your_location")}
            </Text>
            <Text style={[TYPOGRAPHY.TEXT2, { color: COLORS.neutral80 }]}>
              {t("enable_location_description")}
            </Text>
          </View>
          <LazyImage
            imageUrl={images.LocationImage}
            imgStyles={[
              BG_STYLES.bgWhite,
              { height: 220, borderRadius: 8, resizeMode: "contain" },
            ]}
          />
          <Button
            size={SIZE.large}
            text={t("send_location")}
            onClick={handleAddLocation}
          />
        </View>
      </BottomDrawer>
      <BottomDrawer
        visible={subscribed}
        onClose={() => {
          setSubscribed(false);
          setCurrentStep(0);
        }}
      >
        <View style={[COMMON_STYLES.pb1]}>
          <View
            style={[
              BG_STYLES.bgPrimary20,
              COMMON_STYLES["p3/2"],
              COMMON_STYLES.justifyCenter,
              COMMON_STYLES.alignItemsCenter,
              { display: "flex", borderRadius: 16, gap: 16 },
            ]}
          >
            <SuccessIcon />
            <Text
              style={[
                TYPOGRAPHY.HEADING3,
                VARIANTS_STYLES.MEDIUM,
                { color: COLORS.primary100, textAlign: "center" },
              ]}
            >
              {t("subscription_success")}
            </Text>
          </View>
          <View
            style={[
              BG_STYLES.bgNeutral10,
              COMMON_STYLES["p3/2"],
              COMMON_STYLES.mt1,
              { borderRadius: 16, gap: 20 },
            ]}
          >
            <RoundImageWithIcon
              crop={{
                name: cropName || "",
                image_url: cropImage || "",
                id: cropId || 0,
              }}
              key={cropId || 0}
              isIcon
              imageStyle={styles.image}
              imageContainerStyle={styles.iconContainer}
              containerStyle={[COMMON_STYLES.row, COMMON_STYLES.justifyCenter]}
              isImageSelected={false}
            />

            <View>
              <View style={[COMMON_STYLES.row, COMMON_STYLES["mb0.5"]]}>
                <Text style={styles.text}>{t("sowing")}: </Text>{" "}
                <Text
                  style={[styles.text, VARIANTS_STYLES.MEDIUM, { flex: 0.6 }]}
                >
                  {sowingDate}
                </Text>
              </View>
            </View>
          </View>
          <Button
            text={t("okay")}
            onClick={() => {
              setCurrentStep(0);
              setSubscribed(false);
              setFormData({ crop: null, sowingDate: "", latLong: "" });
              setAdvisoryData(null);
            }}
            size={SIZE.large}
            buttonStyle={[COMMON_STYLES.mt1]}
          />
        </View>
      </BottomDrawer>
      <ErrorModal
        visible={errorModalState.show}
        onClose={hideErrorModal}
        message={errorModalState.message}
        allowClose={errorModalState.allowClose}
      >
        {errorModalState.actionNode}
      </ErrorModal>
    </SectionLayout>
  );
};

const styles = StyleSheet.create({
  ctaContainer: { width: 84, marginHorizontal: 40 },
  img84X84: {
    height: 84,
    width: 84,
    borderRadius: 42,
  },
  addCropBtn: {
    borderWidth: 1,
    borderColor: COLORS.primary100,
    backgroundColor: COLORS.primary20,
    alignItems: "center",
    justifyContent: "center",
  },
  ctaText: {
    letterSpacing: -0.25,
  },
  gap1: {
    gap: 16,
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    paddingVertical: 12,
    paddingHorizontal: 20,
    justifyContent: "space-between",
    gap: 20,
  },
  image: {
    height: 40,
    width: 40,
  },
  iconContainer: {
    borderWidth: 1,
    borderColor: COLORS.neutral20,
    marginRight: 10,
  },
  text: {
    flex: 0.4,
    color: COLORS.neutral90,
  },
});

export default CropCalendar;
